export const dismissBackToSchoolModal = () => ({ type: 'DISMISS_BACK_TO_SCHOOL_MODAL'})
export const permenantlyDismissBackToSchoolModal = () => ({ type: 'PERMENANTLY_DISMISS_BACK_TO_SCHOOL_MODAL'})
export const showBackToSchoolModal = (openedFromContextBadge) => ({ type: 'SHOW_BACK_TO_SCHOOL_MODAL',openedFromContextBadge})


// WEBPACK FOOTER //
// ./src/actions/backToSchoolModal.js